<div class="innerpage-fullwithbanner clearfix">
    <h2 class="bighead">Counter Offer</h2>
    <ul class="bread-crumbs">
        <li><a (click)="Validation.redirect('/')">Home<span>|</span></a></li>
        <li *ngIf="isAdmin"><a href="#" [routerLink]="['/offers-list']">Offers<span>|</span></a></li>
        <li><a href="#" routerLink="/offer-detail/{{offerGuid}}">Offer Details<span>|</span></a></li>
        <li>Counter Offer</li>
    </ul>
</div>
<div class="offredetailspage section-margin">
    <div class="container container-lg min-heightcontainer">
        <div class="border-div">
            <div>
                <div class="row" id="cntDiv">
                    <div class="col-lg-8 col-md-8 col-sm-12 col-xs-12" [ngClass]="{'nocontactsin-placeoffer': propertyDetailForOffer.PrimaryContactName==null }">
                        <div class="bg-boxes2 border-div propertydetailstop" style="padding-bottom:10px;">
                            <div class="left">
                                <div class="thumbs2" [ngStyle]="{'background-image': 'url(' + propertyDetailForOffer.FilePath + ')'}"></div>
                                <div class="detailsdiv">
                                    <h4>{{propertyDetailForOffer.PropertyName}}</h4>
                                    <h5><span tooltip="{{propertyDetailForOffer.PropertyType}}">{{ _commonService.GetPropertyTypeWithCount(propertyDetailForOffer.PropertyType)}}</span></h5>
                                    <!--<p>{{propertyDetailForOffer.Description}}</p>
                            <div class="absolutebtn" *ngIf="propertyDetailForOffer.HaveMoreDescription">
                                <button class="blueunerlinelink" container="body" triggers="focus" popover="{{propertyDetailForOffer.MoreDescription}}">More</button>
                            </div>-->
                                </div>
                                <div class="clearfix"></div>
                            </div>
                            <div class="right">
                                <ul>
                                  <li>
                                    <h5>Asking Price</h5>
                                    <div *ngIf="propertyDetailForOffer.Unpriced"><h6>Unpriced</h6></div>
                                    <h6 *ngIf="!propertyDetailForOffer.Unpriced">{{propertyDetailForOffer.Price!=0?('$ '+ (propertyDetailForOffer.Price|number)):'-'}}</h6>
                                  </li>
                                    <li>
                                        <h5>NOI</h5>
                                        <h6>{{propertyDetailForOffer.NOI!=null && propertyDetailForOffer.NOI!=0 ?('$ '+ (propertyDetailForOffer.NOI|number)):'-'}}</h6>
                                    </li>
                                    <li>
                                        <h5>CAP Rate</h5>
                                        <h6>{{propertyDetailForOffer.CapRate!=null && propertyDetailForOffer.CapRate!=0 ?((propertyDetailForOffer.CapRate)+'%'):'-'}}</h6>
                                    </li>
                                </ul>
                            </div>
                            <div class="clearfix"></div>
                        </div>
                    </div>
                    <div class="col-lg-4 col-md-4 col-sm-12 col-xs-12 property-contact" *ngIf="propertyDetailForOffer.PrimaryContactName!=null">
                        <div class="bg-boxes2 border-div">
                            <ul class="contacts">

                                <li class="clearfix">

                                    <div class="imgblock" [ngStyle]="{'background-image': 'url(' + propertyDetailForOffer.PrimaryContactImagePath + ')'}">
                                    </div>
                                    <div class="data">
                                        <h3>{{propertyDetailForOffer.PrimaryContactName!=null?((propertyDetailForOffer.PrimaryContactName)):'-'}} <span>{{propertyDetailForOffer.PrimaryContactRole}}</span></h3>
                                        <p>
                                            <i class="icon-phone icon"></i>{{propertyDetailForOffer.PrimaryContactPhone!=null?(propertyDetailForOffer.PrimaryContactPhone | phone):'-'}}
                                        </p>
                                        <p>
                                            <i class="icon-message icon"></i>
                                            <a href="#">{{propertyDetailForOffer.PrimaryContactEmail!=null?(propertyDetailForOffer.PrimaryContactEmail):'-'}}</a>
                                        </p>

                                    </div>

                                </li>
                            </ul>
                        </div>
                    </div>
                </div>
            </div>


            <div class="margin0">
                <!--<h2 class="mainhead">
            <span class="text">{{counterOfferModel.PropertyName}} | {{counterOfferModel.AskingPrice!=null?('$ '+ (counterOfferModel.AskingPrice|number)):'-'}}</span>
        </h2>-->
                <!--<div class="row   margin-top-30" id="cntDiv">
            <div class="col-lg-8 col-md-8 col-sm-12 col-xs-12" [ngClass]="{'nocontactsin-placeoffer': propertyDetailForOffer.PrimaryContactName==null }">
                <div class="border-div propertydetailstop">
                    <div class="left">
                        <div class="thumbs2" [ngStyle]="{'background-image': 'url(' + propertyDetailForOffer.FilePath + ')'}"></div>
                        <div class="detailsdiv">
                            <h4>{{propertyDetailForOffer.PropertyName}}</h4>
                            <h5 class="categorylabel"><span>{{propertyDetailForOffer.PropertyType}}</span></h5>

                        </div>
                        <div class="clearfix"></div>
                    </div>
                    <div class="right">
                        <ul>
                            <li>
                                <h5>Asking Price</h5>
                                <h6>{{propertyDetailForOffer.Price!=0?('$ '+ (propertyDetailForOffer.Price|number)):'-'}}</h6>
                            </li>
                            <li>
                                <h5>NOI</h5>
                                <h6>{{propertyDetailForOffer.NOI!=null && propertyDetailForOffer.NOI!=0 ?('$ '+ (propertyDetailForOffer.NOI|number)):'-'}}</h6>
                            </li>
                            <li>
                                <h5>CAP Rate</h5>
                                <h6>{{propertyDetailForOffer.CapRate!=null && propertyDetailForOffer.CapRate!=0 ?((propertyDetailForOffer.CapRate)+'%'):'-'}}</h6>
                            </li>
                        </ul>
                    </div>
                    <div class="clearfix"></div>
                </div>
            </div>
            <div class="col-lg-4 col-md-4 col-sm-12 col-xs-12 property-contact" *ngIf="propertyDetailForOffer.PrimaryContactName!=null">
                <div class="border-div">
                    <ul class="contacts">

                        <li class="clearfix">

                            <div class="imgblock" [ngStyle]="{'background-image': 'url(' + propertyDetailForOffer.PrimaryContactImagePath + ')'}">
                            </div>
                            <div class="data">
                                <h3>{{propertyDetailForOffer.PrimaryContactName!=null?((propertyDetailForOffer.PrimaryContactName)):'-'}} <span>- Role</span></h3>
                                <p>
                                    <i class="icon-phone icon"></i>{{propertyDetailForOffer.PrimaryContactPhone!=null?(propertyDetailForOffer.PrimaryContactPhone | phone):'-'}}
                                </p>
                                <p>
                                    <i class="icon-message icon"></i>
                                    <a href="#">{{propertyDetailForOffer.PrimaryContactEmail!=null?(propertyDetailForOffer.PrimaryContactEmail):'-'}}</a>
                                </p>

                            </div>

                        </li>
                    </ul>
                </div>
            </div>
        </div>-->

                <div class="select" *ngIf="isBroker">
                  <div class="row">
                    <div class="col-sm-4">
                      <div class="margin-bottom-15">
                        <label class="form-label">Counter on Behalf of</label>
                        <label class="select">
                          <select class="form-control " [(ngModel)]="optionSelected">
                            <option value="0">--Select--</option>
                            <option *ngFor="let option of options" [(ngValue)]="option.id">{{option.name}}</option>
                          </select>
                          <i></i>
                        </label>
                      </div>
                    </div>
                    <div class="row  margin-bottom-20">
                      <div class="col-lg-3 col-md-3 col-sm-6 col-xs-12 inline-checkbox">
                        <label class="custom-checkbox">
                          <input type="checkbox" [(ngModel)]="counterOfferModel.SendEmail">
                          Send Notification
                          <i></i>
                        </label>
                      </div>

                    </div>
                  </div>
                </div>
                <div class="table-responsive ">
                    <table class="table basictable">
                        <thead>
                            <tr>
                                <th>&nbsp;</th>
                                <th style="width:240px;">Offer</th>
                                <th style="width:310px">Counter</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr>
                                <td><p class="bluetext-p">Price</p></td>
                                <td><p>{{counterOfferModel.OfferPrice!=null?('$ '+ (counterOfferModel.OfferPrice|number)):'-'}}</p></td>
                                <td>
                                  <div class="textbox-with-btn-left">
                                    <input type="text" inputmode="numeric" #counterpriceinput="ngModel" class="form-control" maxlength="18" dropSpecialCharacters="false" mask="separator.10" thousandSeparator=","
                                           [(ngModel)]="counterOfferModel.CounterOfferPrice" (change)="counterPriceValidation()">
                                    <!--<input #counterpriceinput="ngModel" class="form-control" [(ngModel)]="counterOfferModel.CounterOfferPrice" mask="99999999999999" value="{{counterOfferModel.CounterOfferPrice|number}}" (change)="counterPriceValidation()">-->
                                    <span class="leftlabel">$</span>
                                  </div>
                                    <p class="redtext" *ngIf="(counterPriceValid) ||(counterpriceinput.invalid && counterpriceinput.touched)">Offer price should be greater than 0</p>
                                </td>
                            </tr>
                            <tr>
                                <td><p class="bluetext-p">Earnest Money Deposit</p></td>
                                <td><p>{{counterOfferModel.EarnestMoneyDeposit!=null?('$ '+ (counterOfferModel.EarnestMoneyDeposit|number)):'-'}}</p></td>
                                <td>
                                  <div class="textbox-with-btn-left">
                                    <input type="text" inputmode="numeric" #earnestmoneydepositinput="ngModel" class="form-control" maxlength="18" dropSpecialCharacters="false" mask="separator.10" thousandSeparator=","
                                           [(ngModel)]="counterOfferModel.CounterEarnestMoneyDeposit" (change)="earnestmoneyDepositValidation()">
                                    <!--<input #earnestmoneydepositinput="ngModel" class="form-control" [(ngModel)]="counterOfferModel.CounterEarnestMoneyDeposit" mask="99999999999999" value="{{counterOfferModel.CounterEarnestMoneyDeposit|number}}" (change)="earnestmoneyDepositValidation()">-->
                                    <span class="leftlabel">$</span>
                                  </div>
                                    <p class="redtext" *ngIf="(earnestmoneyDepositValid) ||(earnestmoneydepositinput.invalid && earnestmoneydepositinput.touched)">Earnest Money Deposit should be greater than 0</p>
                                </td>
                            </tr>
                            <tr>
                                <td><p class="bluetext-p">Due Diligence Period</p></td>
                                <td><p>{{counterOfferModel.DueDiligencePeriod!=null?(counterOfferModel.DueDiligencePeriod)+' Days':'-'}}</p></td>
                                <td>
                                    <div class="textbox-with-btn textbox-with-4character">
                                        <input class="form-control" [(ngModel)]="counterOfferModel.CounterDueDiligencePeriod" mask="999">
                                        <span class="rightlabel">Days</span>
                                    </div>
                                </td>
                            </tr>
                            <tr>
                                <td><p class="bluetext-p">Closing Period</p></td>
                                <td><p>{{counterOfferModel.ClosingPeriod!=null?(counterOfferModel.ClosingPeriod)+' Days':'-'}} </p></td>
                                <td>
                                    <div class="textbox-with-btn textbox-with-4character">
                                        <input class="form-control" [(ngModel)]="counterOfferModel.CounterClosingPeriod" mask="999">
                                        <span class="rightlabel">Days</span>
                                    </div>
                                </td>
                            </tr>
                        </tbody>
                    </table>
                </div>
                <!--<div class="add-attachments clearfix margin-top-20 margin-bottom-20">
            <div  class="uploadfile  btn  btn-circle btn-green " placement="top" tooltip="Add Attachments">
                <input  class="fileupload" multiple="" type="file">
                <span  class="icofont icofont-upload-alt icon"></span>
            </div>
            <h5>Add Attachments</h5>
        </div>-->
                <h3 class="bluelabel margin-top-20">Add Attachments</h3>



                <file-upload [uploadType]="fileUploadType" (selectedFilesListEmitter)=selectedFilesListEmitterForLOI($event) [maxFiles]="1" [showList]="false" [extensionType]="fileExtensionType" [extensionLOIType]="fileExtensionLOIType" [clearFilescounter]="clearFiles" [fileTypes] ="fileTypes"></file-upload>
                <label class="alert-danger">{{errorMessage}}</label>
                <div class="table-responsive">

                    <table class="table basictable fixedlayouttable" *ngIf="filesCollectionLOI.length > 0">
                        <thead>
                            <tr>
                                <th class="minwidth40">File</th>
                                <th class="minwidth40">Category</th>
                                <th class="minwidth20">Action</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr *ngFor="let file of filesCollectionLOI;let i = index" [attr.data-index]="i">
                                <td><p>{{file.name}}</p></td>
                                <td>
                                    <label>
                                        <!--<select class="form-control " [(ngModel)]="file.category" >
                                    <option value="0">Additional Document</option>
                                </select>
                                <i></i>-->
                                        <label>Counter LOI Document</label>
                                    </label>
                                </td>
                                <td>
                                    <a class="remove" href="javascript:void(0);" (click)="onRemoveCounterDocument(i)" tooltip="Remove"><i aria-hidden="true" class="icofont icofont-close"></i></a>
                                </td>

                            </tr>
                        </tbody>
                    </table>
                </div>
                <!--<ul class="imglisting informationupload">
            <li class="addnew">
                <file-upload (selectedFilesListEmitter)=selectedFilesListEmitter($event) [uploadType]="fileUploadType" [extensionType]="fileExtensionType" [clearFilescounter]="clearFiles"></file-upload>
                <label class="alert-danger">{{errorMessage}}</label>
            </li>
        </ul>-->
                <div class="row">
                    <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12">
                        <div class="form-group">
                            <label class="form-label">Comments</label>
                            <textarea class="form-control textarea-min-height" [(ngModel)]="counterOfferModel.Comments" maxlength="480"></textarea>
                        </div>
                    </div>
                </div>
                <div class="text-right">
                    <button class="btn btn-default btn-lg" (click)="cancel()">Cancel</button>
                    <button class="btn btn-success btn-lg " [disabled]="disabledCounterBtn" (click)="saveCounter()">Counter</button>

                </div>
            </div>
        </div>
       

    </div>
</div>

